import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
// import { formatNumber } from "../../../../components/formatNumber";

const FarmerDetail = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [totalItems, setTotalItems] = useState(0);
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [cropId, setCropId] = useState("");
  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [fields, setFields] = useState([]);

  const [exportFields, setExportFields] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [seasonName, setSeasonName] = useState("");
  const [seasonData, setSeasonData] = useState([]);
  const [cropFilterList, setCropFilterList] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";

    const number = Number(value);

    if (isNaN(number)) return value;

    return number.toLocaleString("en-NG");
  };





  const { sendRequest: getWarehouseData } = useHttp();
  const { sendRequest: getSeasonList } = useHttp();

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = (employeeId, regionId, farmerNumber) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNumber != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }
    if (seasonName !== "") {
      urlfilter = urlfilter + `&seasonId=${seasonName}`;
    }
    if (cropId !== "") {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }


    var url = `/api/farmerDetailreport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}&page=${currentPage}&limit=50${urlfilter}`;

    getprocurementData(
      {
        url: url,
      },
      (res) => {
        console.log("reportdata", res);
        setData(res.data);
        setTotalItems(res.total);
        if (res) {
          const activeFields = res?.fields
            ?.filter((f) => f.status === 1)
            ?.sort((a, b) => a.sequenceNo - b.sequenceNo);

          setFields(activeFields);
          const fieldsToExport = activeFields?.map((f) => f.dataField);
          const customHeaders = activeFields?.map((f) => f.headerField);

          setExportFields(fieldsToExport);
          setExportHeaders(customHeaders);
        }
      }
    );
  };

  useEffect(() => {
    fillprocurementData(employeeId, regionId, farmerNumber);
  }, [currentPage]);

  // const handleExportExcel = () => {
  //   if (!data || data.length === 0) {
  //     toast.error("No data available to export!");
  //     return;
  //   }
  //   const filename = "FarmerDetail.xlsx";

  //   convertToExcel(data, exportFields, filename, exportHeaders);
  // };


  const handleExportExcel = () => {

    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    if (farmerNumber !== "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }

    if (seasonName !== "") {
      urlfilter = urlfilter + `&seasonId=${seasonName}`;
    }

    if (cropId !== "") {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }

    const url = `/api/farmerDetailreport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem(
      "empId"
    )}&isExport=true${urlfilter}`;

    getprocurementData(
      {
        url: url,
      },
      (res) => {

        if (!res.data || res.data.length === 0) {
          toast.error("No data available to export!");
          return;
        }

        const filename = "FarmerDetail.xlsx";

        convertToExcel(
          res.data,
          exportFields,
          filename,
          exportHeaders
        );
      }
    );
  };


  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);
  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("Crop API Full Response:", res);
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);





  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (data) => {
        setFarmerNumber("");
        setFarmerData(data);
      }
    );
  }, [employeeId]);

  useEffect(() => {
    getSeasonList(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("Season API Response:", data);
        setSeasonData(data);
      }
    );
  }, [getSeasonList]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerNoData&&farmerNoData.map(item => ({ value: item.farmerNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Detail</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Region</label>
                  <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      var regid = 0;

                      if (e.target.value != "--Select--") {
                        regid = e.target.value;
                      }
                      setRegionId(regid);
                      EmployeeDetail(regid);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option
                          key={x.regionId}
                          user-id={x.regionId}
                          value={x.regionId}
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Executive Officer
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>
                  <select
                    id="cropNameId"
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>

                    {cropFilterList &&
                      cropFilterList.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>

                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="identification_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="seasonName">Season Name</label>
                  <select
                    id="seasonName"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonName"] = el)}
                    value={seasonName}
                    onChange={(e) => {
                      setSeasonName(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>

                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div> */}
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId, farmerNumber);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      padding: "0.4rem",
                      maxHeight: "600px", // adjust height as needed
                      overflowY: "auto",
                      overflowX: "auto",
                    }}
                  >
                    <table
                      className="table table-bordered text-center table-sm"
                      style={{ minWidth: "1600px" }} // optional: set min width for wide data
                    >
                      <thead
                        style={{
                          // position: "sticky",
                          top: 0,
                          zIndex: 2,
                          background: "#f8f9fa",
                        }}
                      >
                        <tr className="table-header">
                          {fields?.map((field, index) => (
                            <th key={index} style={{ whiteSpace: "nowrap" }}>
                              {field.headerField}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems?.map((itm, i) => (
                          <tr key={i} className="tablerowview">
                            {fields?.map((field, j) => {
                              const value = itm[field.dataField];

                              if (field.dataField === "urlProfile") {
                                return (
                                  <td key={j}>
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                      className="user-image img-circle"
                                      width="60"
                                      height="60"
                                      alt="Profile"
                                    />
                                  </td>
                                );
                              }

                              if (field.dataField === "urlAttachment") {
                                return (
                                  <td key={j}>
                                    <a
                                      href={`${process.env.REACT_APP_FILE_URL}${value}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Id Proof
                                    </a>
                                  </td>
                                );
                              }

                              if (field.dataField === "signatureAttachment") {
                                return (
                                  <td key={j}>
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                      className="user-image img-circle"
                                      alt="Signature"
                                      height="60"
                                      width="60"
                                    />
                                  </td>
                                );
                              }
                              const amountFields = [
                                "amount",
                                "cost",
                                "totalAmount",
                                "baselineIncome",
                                "price",
                                "commitmentFeePayment",
                              ];
                              if (amountFields.includes(field.dataField)) {
                                return <td key={j}>{formatNumber(value)}</td>;
                              }
                              return <td key={j}>{value}</td>;
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerDetail;
